import { ApplicationConfig, importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideTransloco } from '@jsverse/transloco';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslocoRootModule } from './transloco-root.module';
import { TranslocoHttpLoader } from './transloco.loader';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { environment } from '@environment/environment';
import { BackendApiModule, BrokernetLanguageType, Configuration as BackendConfiguration } from './api/backend';

registerLocaleData(localeDe, 'de');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(
      BackendApiModule.forRoot(() => {
        return new BackendConfiguration({
          basePath: environment.bppBackend,
          withCredentials: true
        });
      })
    ),
    provideTransloco({
      config: {
        availableLangs: [BrokernetLanguageType.De, BrokernetLanguageType.En],
        reRenderOnLangChange: true,
        prodMode: !isDevMode()
      },
      loader: TranslocoHttpLoader
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'light-mode'
        }
      }
    }),
    { provide: LOCALE_ID, useValue: 'de' },
    importProvidersFrom(BrowserAnimationsModule, TranslocoRootModule)
  ]
};
